export * from './src/restaurants-catalogs-v3-discount-discount.schemas.js';
